import {Base} from "@/api/Base"

export class CommissionRateAdd extends Base {
    path = "commissionRate/add"
}